import PropTypes from 'prop-types'
import React from 'react'

import ChoiceOption from './choice-option'

const ChoiceList = ({
  options = [],
  name,
  hasError,
  isMulti = false,
  required = false,
}) => {
  const type = isMulti ? 'checkbox' : 'radio'
  return (
    <div>
      {options.map((o, index) => (
        <ChoiceOption
          key={o.value}
          type={type}
          value={o.value}
          name={name}
          hasError={hasError}
          required={required}
          style={{
            paddingLeft: index === 0 ? 0 : undefined,
          }}
        >
          {o.label}
        </ChoiceOption>
      ))}
    </div>
  )
}

ChoiceList.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  name: PropTypes.string,
  hasError: PropTypes.bool,
  isMulti: PropTypes.bool,
  required: PropTypes.bool,
}

export default ChoiceList
